import { render, staticRenderFns } from "./UserPie.vue?vue&type=template&id=7c48468f&scoped=true&"
import script from "./UserPie.vue?vue&type=script&lang=js&"
export * from "./UserPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48468f",
  null
  
)

export default component.exports